module.exports = __webpack_public_path__ + "static/media/watch.98840165.png";